const RECENT_EVENT_WINDOW_DAYS = 180;
const RECENT_EVENT_WINDOW_MS = RECENT_EVENT_WINDOW_DAYS * 24 * 60 * 60 * 1000;

interface SeoEvent {
  privacy?: string | null;
  startDateTime?: string | null;
  status?: string | null;
  type?: string | null;
}

export const isIndexableEventForSeo = (event?: SeoEvent | null, now = new Date()) => {
  if (!event?.startDateTime) {
    return false;
  }

  const startTime = new Date(event.startDateTime).getTime();

  if (!Number.isFinite(startTime)) {
    return false;
  }

  return (
    event.type === 'TOURNAMENT' &&
    event.status === 'PUBLISHED' &&
    event.privacy === 'PUBLIC' &&
    startTime >= now.getTime() - RECENT_EVENT_WINDOW_MS
  );
};
